<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <b-sidebar
    type="is-light"
    :fullheight="fullheight"
    :fullwidth="fullwidth"
    :overlay="overlay"
    :right="right"
    :can-cancel="cancancel"
    v-model="openDrawer"
    :class="[size == 'big' ? 'big-modal' : '']"
  >
    <div class="header">
      <div class="header-section">
        <img class="back-icon" :src="backIcon" @click="close()" />{{ title }}
      </div>
      <hr />
    </div>
    <div class="content drawer-content">
      <slot v-if="openDrawer" ref="childComponent"></slot>
    </div>
    <div ref="draft" class="draft">
      <div class="draft-space"></div>
      <div class="draft-message">
        <div class="draft-message-content">
          <div class="draft-message-icon">
            <img :src="draftAlert" />
          </div>
          <div class="draft-message-label">
            Você possui algumas alterações que não foram salvas. O que deseja
            fazer?
          </div>
        </div>
        <div class="draft-message-buttons">
          <div class="button btn-back-initial" @click="close(true)">
            Sair sem salvar
          </div>
          <button class="button is-primary" @click="keepEditing()">
            Continuar editando
          </button>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { mapActions } from 'vuex'
import backIcon from '@/assets/img/arrow-back.svg'
import draftAlert from '@/assets/img/draft-alert.svg'

export default {
  data() {
    return {
      openDrawer: false,
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: true,
      cancancel: false,
      mobile: 'fullwidth',
      size: 'normal',
      backIcon,
      draftAlert,
      title: '',
    }
  },

  methods: {
    ...mapActions({
      setIsEditing: 'gifts/setIsEditing',
    }),
    open(config) {
      this.title = config.title
      this.openDrawer = true
      this.size = config.size
      this.setIsEditing(true)
    },
    keepEditing() {
      this.$refs.draft.style.display = 'none'
    },
    close(draft) {
      this.setIsEditing(false)
      if (draft) {
        localStorage.setItem('drawer-draft', false)
      }

      if (localStorage.getItem('drawer-draft') == 'true') {
        this.$refs.draft.style.display = 'flex'
      } else {
        this.$refs.draft.style.display = 'none'
        this.openDrawer = false
      }
    },
  },
}
</script>

<style lang="scss">
.draft {
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  align-items: end;

  .draft-message {
    height: 338px;
    width: 100%;
    background-color: #fff;

    .draft-message-content {
      height: 230px;
      text-align: center;

      .draft-message-icon {
        img {
          margin-top: 40px;
          width: 88px;
          height: 88px;
        }
      }

      .draft-message-label {
        display: inline-flex;
        color: $neutral;
        margin-top: 24px;
        font-size: 16px;
        font-weight: 400;
        width: 322px;
        height: 38px;
        line-height: 19px;
      }
    }

    .draft-message-buttons {
      height: 88px;
      margin-top: 24px;
      text-align: center;
      display: flex;
      align-items: center;
      vertical-align: middle;
      justify-content: space-evenly;
      border-top: 1px solid $neutrallight;

      .button {
        height: 56px;
        font-size: 18px;
        border-radius: 100px;
        padding-left: 20px;
        padding-right: 20px;

        @media (max-width: $mobile) {
          width: auto;
          height: 56px;
        }

        img {
          margin-right: 8px;
        }
      }

      .btn-back-initial {
        font-weight: 700;
        color: $neutral;
        border: 1px solid $neutral;
        border-radius: 100px;
      }
    }
  }
}

.big-modal {
  @media (min-width: $tablet) {
    .sidebar-content {
      width: 100vw !important;
      max-width: 832px;
      overflow: overlay !important;
    }
  }
}

.header {
  position: fixed;
  width: 100%;
  background: white;
  height: 66px;
  z-index: 999;

  .header-section {
    margin-top: 16px;
    color: $neutral;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    height: 32px;

    .back-icon {
      margin-left: 16px;
      margin-right: 16px;
      cursor: pointer;
      width: 22px;
      height: 22px;
    }
  }

  hr {
    margin-top: 16px;
    border: 1px solid $neutrallight;
    box-shadow: 0px 2px 4px rgba(93, 117, 141, 0.3);
  }
}

.drawer-content {
  position: static;
  margin: 64px 0 0 !important;

  .content {
    min-height: calc(100vh - 132px);
    margin: 0 !important;
    padding: 24px 16px 100px;
    @media screen and (min-width: $mobile) {
      padding: 40px 32px 100px;
    }
  }

  .footer {
    position: sticky;
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 66px;
    padding: 11px 20px;
    border-top: 1px solid $neutrallight;
    background: #fff;
    box-shadow: 0px -1px 4px rgba(93, 117, 141, 0.3);

    .footer-content {
      text-align: center;
    }
  }
}
</style>
